module.exports = __webpack_public_path__ + "media/images/flags/FO-53e42f6be01157e97ac2938cb385e5a6.svg";